import { LayoutsHome, LayoutsLogin } from "../layouts";
import { CustomLayout } from "../components/layouts";
import {
    PageHome,
    PageLogin,
    PagePpe,
    PageSubsidiary,
    PageUser,
} from "../modules";
import { PageGang } from "../modules/modules.hrm/pages.hrm/PageGang";
import { PageDeleteData } from "../modules/modules.deletedata/pages.deletedata/PageDeleteData";
import { PageSchedule } from "../modules/modules.hrm/pages.hrm/PageSchedule";
import { PageRole } from "../modules/modules.hrm/pages.hrm/PageRole";
const routesHRM = [
    {
        path: "/",
        layout: CustomLayout,
        component: PageHome,
    },
    {
        path: "/login",
        layout: LayoutsLogin,
        component: PageLogin,
    },
    {
        path: "/schedules",
        layout: CustomLayout,
        component: PageSchedule,
    },
    {
        path: "/delete-data",
        layout: LayoutsLogin,
        component: PageDeleteData,
    },
    {
        path: "/employees",
        layout: CustomLayout,
        component: PageUser,
    },
    {
        path: "/subsidiaries",
        layout: CustomLayout,
        component: PageSubsidiary,
    },
    {
        path: "/gangs",
        layout: CustomLayout,
        component: PageGang,
    },
    {
        path: "/epps",
        layout: CustomLayout,
        component: PagePpe,
    },
    {
        path: "/roles",
        layout: CustomLayout,
        component: PageRole,
    },
];
export default routesHRM;
